import { createReducer } from 'redux/shelf';
import { get, post } from 'redux/shelf/api';

export const actions = {
  fetchSubscriptionId: get`settings/shopify/getRecurrentCharge`(),
  removeNonProrated: post`settings/shopify/cancelChargeWithoutProrate`(),
  removeProrated: post`settings/shopify/cancelChargeWithProrate`(),
};

export const reducer = createReducer(actions);
